import React, { Component } from "react";
import { connect } from "react-redux";
import { getProducts } from "../actions/productActions";
import { setPager } from "../actions/pagerActions";
import ProductCard from "../components/ProductCard";
import { withRouter } from "react-router";
import { withTranslation } from 'react-i18next';
/*import Alert from "../components/Alert";*/


class ProductList extends Component {

    componentDidMount() {
        const { props } = this;

        if (props.isSearch === true) {
            this.loadProducts(null, props.match.params.searchTerm);
        } else {
            this.loadProducts(props.match.params.id, null);
        }
    };

    loadProducts(groupId, searchTerm) {
        const { pager, settings } = this.props;
         this.props.setPager( 1, 1 );
        this.props.getProducts(
             1,
             settings.pageSize,
            groupId,
            searchTerm).then((response) => {

        }, (error) => {
        });
    };


    componentDidUpdate(prevProps) {
        const nextId = this.props.match.params.id;
        const nextSearchTerm = this.props.match.params.searchTerm;
        if (this.props.isSearch === true && prevProps.match.params.searchTerm !== nextSearchTerm) {
            this.loadProducts(null, nextSearchTerm);
        }
        else if (this.props.isSearch !== true && prevProps.match.params.id !== nextId) {
            this.loadProducts(nextId, null);
        }

        if (this.props.products !== prevProps.products) {
            this.props.setPager(
                this.props.pager.activePage,
                this.props.products.totalPages
            );
        }
    }
    render() {
        const { products, settings, t } = this.props;
        if (!products || !products.items || products.items.length === 0) return <div />;

       // if (!products || !products.items) return <Alert type="info" title={t("List Products")} msg={t("No products found in this category.")} />;


        var productsList = products.items.map(product => (
            <ProductCard
                key={product.id}
                isHorizontal={false}
                product={product}
                settings={settings}
                listName="categories"
                listId={this.props.match.params.id}
                className= "col-12 col-sm-6 col-md-4 col-lg-3 mb-2"
            />
        ));

        return (
            <div ref="isotopeGrid" className=" row mb-2">
                {/*<div className="gutter-sizer" />*/}
                {/*<div className="grid-sizer" />*/}
                {productsList}
               
            </div>
        );
    }
}

function mapStateToProps({  products, settings, pager }, ownProps) {
    return { products, settings, pager, ...ownProps };
}

export default withTranslation()(withRouter(connect(mapStateToProps, { getProducts, setPager }, null, { forwardRef: true })(ProductList) ));
